import PropTypes from 'prop-types';

const LINE_STYLES = 'relative grow h-0.5 m-0 leading-none';

const LineBar = ({ isActive, isComplete, steps }) => {
  if (!isActive)
    return (
      <div
        aria-hidden="true"
        className={`${LINE_STYLES} ${isComplete ? 'bg-green-3' : 'bg-gray-3'}`}
      />
    );

  const stepLines = [...steps.values()].map((step, i) => (
    <div
      aria-hidden="true"
      className={`${LINE_STYLES} ${
        step.isComplete ? 'bg-green-3' : 'bg-gray-3'
      }`}
      // eslint-disable-next-line react/no-array-index-key
      key={i}
    />
  ));

  return stepLines;
};

LineBar.propTypes = {
  isActive: PropTypes.bool,
  isComplete: PropTypes.bool,
  steps: PropTypes.instanceOf(Map).isRequired,
};

LineBar.defaultProps = {
  isActive: false,
  isComplete: false,
};

export default LineBar;
